/**
 * Staff Forgot Password Page
 * Self-service password reset workflow with 2FA support
 */

import { ForgotPassword } from '@/components/auth/ForgotPassword';

export default function StaffForgotPasswordPage() {
  return <ForgotPassword />;
}
